import DownLoadIcons from '@/icons/DownLoadIcons'
import { exportContactSource } from '@/modules/Marketing/services'
import { IPermissionProps } from '@/types/shared'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { Button } from 'vnetwork-ui'

const ExportContactButton: React.FC<IPermissionProps> = () => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()

    const handleExport = async () => {
        try {
            const filters = searchParams.get('filters') || ''
            const q = searchParams.get('q') || ''
            const payload = {
                page: 1,
                page_size: 99999,
                filters: filters || undefined,
                q: q || '',
            }
            const response = await exportContactSource(payload)
            // Tạo URL từ Blob
            const url = window.URL.createObjectURL(new Blob([response]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'download',
                `contacts_${new Date().toISOString()}.xlsx`
            )
            // Kích hoạt tải file
            document.body.appendChild(link)
            link.click()
            // Dọn dẹp bộ nhớ
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
            toast.success(t('dowload-success'))
        } catch (error) {
            console.error('Lỗi khi tải file Excel:', error)
            toast.error(t('download-failed'))
        }
    }

    return (
        <div data-tour="export-btn">
            <Button
                size="small"
                variant="outlined"
                startIcon={<DownLoadIcons />}
                onClick={handleExport}
            >
                {t('download')}
            </Button>
        </div>
    )
}

export default ExportContactButton
